import { jsx as _jsx } from "react/jsx-runtime";
const SvgCharacter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 9,
	height: 8,
	viewBox: "0 0 9 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.08288 7.65731C8.05545 7.70483 8.01599 7.74429 7.96847 7.77171C7.92095 7.79914 7.86705 7.81358 7.81218 7.81356H0.31218C0.257352 7.81351 0.203503 7.79903 0.156042 7.77158C0.108581 7.74412 0.0691766 7.70467 0.041787 7.65717C0.0143973 7.60968 -1.40657e-05 7.55581 1.03015e-08 7.50098C1.40863e-05 7.44615 0.0144531 7.3923 0.0418671 7.34481C0.636789 6.3163 1.55359 5.5788 2.62351 5.22919C2.09428 4.91413 1.6831 4.43406 1.45311 3.8627C1.22313 3.29134 1.18706 2.66028 1.35044 2.06644C1.51382 1.47259 1.86762 0.948794 2.3575 0.575486C2.84739 0.202178 3.44627 0 4.06218 0C4.67809 0 5.27697 0.202178 5.76686 0.575486C6.25674 0.948794 6.61054 1.47259 6.77392 2.06644C6.9373 2.66028 6.90123 3.29134 6.67125 3.8627C6.44126 4.43406 6.03008 4.91413 5.50085 5.22919C6.57077 5.5788 7.48757 6.3163 8.08249 7.34481C8.10998 7.39228 8.12449 7.44616 8.12455 7.50101C8.12462 7.55587 8.11025 7.60977 8.08288 7.65731Z",
		fill: "currentColor"
	})
});
export default SvgCharacter;
